import { GithubFormat } from "../pages/game/utils/formatCode";
import { TEMPLATE_TYPE } from "./config";

export const getTemplate = (code: GithubFormat): TEMPLATE_TYPE => {
    let templateType: TEMPLATE_TYPE = 'phaser-react';

    if (code.length > 1) {
        if (code.find(item => item.path.includes('src/index.tsx'))) {
            templateType = 'phaser-react';
        } else {
            templateType = 'phaser';
        }
    } else {
        templateType = 'single';
    }

    // console.log('templateType:', templateType);
    return templateType as TEMPLATE_TYPE;
};